import { render, staticRenderFns } from "./Drafts.vue?vue&type=template&id=0978aa30"
import script from "./Drafts.vue?vue&type=script&lang=js"
export * from "./Drafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports